import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const finalizeArchiveTrial = async ({ trialId, taskId, ecrfFailedVisits }) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${__API_URL__}/api/photos/trials/${trialId}/archive-finalize/`,
    { task_id: taskId, ecrf_failed_visits: ecrfFailedVisits },
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

const useFinalizeArchiveTrialMutation = () => {
  return useMutation({
    mutationFn: finalizeArchiveTrial,
  });
};

export default useFinalizeArchiveTrialMutation;
